export { default as ProductsImageFilterBadge } from './ProductsImageFilterBadge';
